// Boot mínimo para forzar que el WebView NO use el área de la notch
import { StatusBar } from '@capacitor/status-bar';

(async () => {
  try {
    await StatusBar.setOverlaysWebView({ overlay: false });
    // Si quieres ajustar iconos más adelante:
    // import { Style } from '@capacitor/status-bar';
    // await StatusBar.setStyle({ style: Style.Light }); // o Style.Dark
  } catch (e) {
    // En web/desktop no pasa nada si falla; en nativo funcionará
    console.log('[cap] StatusBar init skipped:', e?.message || e);
  }
})();
